module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'advertiseManager'
      }
    }
  }, [_vm._v("广告管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("发布广告")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "materiaForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.materiaForm,
      "rules": _vm.materiarules,
      "label-width": "100px",
      "label-position": _vm.labelposition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "广告名称",
      "prop": "advName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.materiaForm.advName),
      callback: function($$v) {
        _vm.$set(_vm.materiaForm, "advName", $$v)
      },
      expression: "materiaForm.advName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.getStartDate
    },
    model: {
      value: (_vm.materiaForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.materiaForm, "startTime", $$v)
      },
      expression: "materiaForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.getEndDate
    },
    model: {
      value: (_vm.materiaForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.materiaForm, "endTime", $$v)
      },
      expression: "materiaForm.endTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "check"
  }, [_c('el-col', {
    attrs: {
      "span": 26
    }
  }, [_c('el-tabs', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    attrs: {
      "type": "card",
      "element-loading-text": "正在发布，请耐心等待。"
    },
    on: {
      "tab-click": _vm.tabsClick
    },
    model: {
      value: (_vm.activeName2),
      callback: function($$v) {
        _vm.activeName2 = $$v
      },
      expression: "activeName2"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "third"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v("机器选择")]), _vm._v(" "), _c('el-transfer', {
    staticClass: "transfer-size",
    attrs: {
      "props": {
        key: 'fxDeviceId',
        label: 'deviceName'
      },
      "filterable": "",
      "titles": ['可选择', '已选择'],
      "footer-format": {
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      },
      "data": _vm.kioskData
    },
    model: {
      value: (_vm.resvalue),
      callback: function($$v) {
        _vm.resvalue = $$v
      },
      expression: "resvalue"
    }
  }, [_c('el-pagination', {
    staticClass: "pagina",
    attrs: {
      "slot": "left-footer",
      "small": "",
      "current-page": _vm.currentpage,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    },
    slot: "left-footer"
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "controll"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pushResource('materiaForm')
      }
    }
  }, [_vm._v("发布")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("返回")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-121829d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/market/AdPush.vue
// module id = 1035
// module chunks = 2